import React from "react";
import Navb from "../../../../components/navbar/Navb";
import Footer from "../../../../components/footer/Footer";
import Img1 from "./img1.png";
import Recpiesimg1 from "./recpiesimg1.png";
import Recpiesimg2 from "./recpiesimg2.png";
import Recpiesimg3 from "../../img13.png";
import Recpiesimg4 from "../../img4.png";
import Recpiesimg5 from "../../img7.png";
import RecipiePage from "../../../../components/recipiePage/RecipiePage";
import Timer from "../timer.png";
import "../recipe.css";
const Soojidhokla = () => {
  return (
    <>
      <RecipiePage
        Recpiesimg1={Recpiesimg1}
        Recpiesimg2={Recpiesimg2}
        Recpiesimg3={Recpiesimg3}
        Recpiesimg4={Recpiesimg4}
        Recpiesimg5={Recpiesimg5}
        Img1={Img1}
        Name="Sooji Dhokla"
        Ul1={
          <ul>
            <li>
            <span className="Bold">Nandi besan (chickpea flour)</span>
            </li>
            <li>yogurt</li>
            <li>water</li>
            <li>ginger, grated</li>
            <li>green chili, finely chopped</li>
            <li>turmeric powder</li>
          </ul>
        }
        Ul2={
          <ul className="noDecoration">
            <li>1 cups</li>
            <li>2 cups</li>
            <li>4 cups</li>
            <li>1 tablespoon</li>
            <li>1 piece</li>
            <li>1/2 tablespoon</li>
          </ul>
        }
        Ul3={
          <ul>
            <li>ghee</li>
            <li>mustard seeds</li>
            <li>cumin seeds</li>
            <li>fenugreek seeds</li>
            <li>red chilies</li>
            <li>asafoetida (hing)</li>
          </ul>
        }
        Ul4={
          <ul className="noDecoration">
            <li>2 tablespoons</li>
            <li>1 tablespoon</li>
            <li>1 tablespoon</li>
            <li>1/2 tablespoon</li>
            <li>2-3 dried</li>
            <li>A pinch</li>
          </ul>
        }
        Ol1={
          <ol>
            <li>
              In a bowl, mix sooji, yogurt, water, ginger-green chili paste, and
              salt. Let it rest for 15-20 minutes.
            </li>
            <li>
              Grease a steaming tray or dhokla plate. Add baking soda to the
              batter and mix well. Pour the batter into the tray.
            </li>
            <li>
              Steam the batter for about 15-20 minutes or until a toothpick
              inserted comes out clean.
            </li>
            <li>
              In a small pan, heat oil. Add mustard seeds, sesame seeds, curry
              leaves, and asafoetida for tempering.
            </li>
            <li>Pour the tempering over the steamed dhokla.</li>
            <li>
              Cut into squares, garnish with fresh coriander leaves, and serve
              with green chutney.
            </li>
          </ol>
        }
        Item1="Nandi Sabji Masala"
        Item2="Maida Pizza Cone"
        Item3="Besan burfi "
        Link1="nandisabjimasala"
        Link2="maidavegpizzacones"
        Link3="besanburfi"
      />
      {/* <Navb />
      <div className="singleRecipeTop">Sooji Dhokla</div>
      <img className="singleRecipeTopimg" src={Recpiesimg1} alt="Recpiesimg1" />
      <div className="singleRecipeBot">
        <div className="singleRecipeBotLeftItems">
          <div className="singleRecipeBotLeftItemTitle">INGREDIENTS</div>
          <hr />
          <div className="singleRecipeBotLeftItem">
            <div className="singleRecipeBotLeftItemTop">For Kadhi:</div>
            <ol>
              <li>
                1 cup <span className="Bold">Nandi besan (chickpea flour)</span>{" "}
              </li>
              <li>2 cups yogurt</li>
              <li>4 cups water</li>
              <li>1 teaspoon ginger, grated</li>
              <li>1 green chili, finely chopped</li>
              <li>1/2 teaspoon turmeric powder</li>
              <li>Salt to taste</li>
            </ol>
          </div>
          <div className="singleRecipeBotLeftItem">
            <div className="singleRecipeBotLeftItemTop">For Tempering:</div>
            <ol>
              <li>2 tablespoons ghee</li>
              <li>1 teaspoon mustard seeds</li>
              <li>1 teaspoon cumin seeds</li>
              <li>1/2 teaspoon fenugreek seeds </li>
              <li>2-3 dried red chilies</li>
              <li>A pinch of asafoetida (hing)</li>
              <li>Curry leaves</li>
            </ol>
          </div>
          <hr />
          <div className="flexitemrecipe">
            <img src={Recpiesimg2} alt="Recpiesimg2" />
            Nandi Besan
          </div>
        </div>
        <div className="singleRecipeBotRight">
          <div className="singleRecipeBotRightTop">Instructions</div>
          <ol>
            <li>
              In a bowl, mix sooji, yogurt, water, ginger-green chili paste, and
              salt. Let it rest for 15-20 minutes.
            </li>
            <li>
              Grease a steaming tray or dhokla plate. Add baking soda to the
              batter and mix well. Pour the batter into the tray.
            </li>
            <li>
              Steam the batter for about 15-20 minutes or until a toothpick
              inserted comes out clean.
            </li>
            <li>
              In a small pan, heat oil. Add mustard seeds, sesame seeds, curry
              leaves, and asafoetida for tempering.
            </li>
            <li>Pour the tempering over the steamed dhokla.</li>
            <li>
              Cut into squares, garnish with fresh coriander leaves, and serve
              with green chutney.
            </li>
          </ol>
        </div>
      </div>
      <div className="singleRecipeEnd">
        <div className="singleRecipeEndTitle">You Might Also Like</div>
        <div className="singleRecipeEndItems">
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
              <a href="/recipes/mixvegparatha">
                <img src={Recpiesimg3} alt="Recpiesimg3" />
                <div className="singleRecipeEndItemTitle">Mix Veg Paratha</div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 50 mins</span>
            </div>
          </div>
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
              <a href="/recipes/Nandisabjimasala">
                <img src={Recpiesimg4} alt="Recpiesimg4" />
                <div className="singleRecipeEndItemTitle">
                  Nandi Sabji Masala
                </div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 40 mins</span>
            </div>
          </div>
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
              <a href="/recipes/wholeattavegmomos">
                <img src={Recpiesimg5} alt="Recpiesimg5" />
                <div className="singleRecipeEndItemTitle">
                  Whole Atta Veg Momos
                </div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 40 mins</span>
            </div>
          </div>
        </div>
      </div>
      <Footer /> */}
    </>
  );
};

export default Soojidhokla;
